import React, { useContext, useState } from "react";
import Venue, { VenuePlaceholder } from "../Venue";
import SearchContext from "contexts/searchContext";
import Pagination from 'react-bootstrap/Pagination';

const ListView = ({ pageCount }) => {

    const { loading, results, searchValue } = useContext(SearchContext);
    const [page, setPage] = useState(1);

    const getPages = () => {
        if (!pageCount) return 1;
        if (!results.hits?.length) return 1;

        return Math.ceil(results.hits?.length / pageCount);
    };

    const getPagedResults = () => {
        if (!pageCount) return results.hits;

        return results.hits?.slice((page - 1) * pageCount, (page) * pageCount);
    }

    const sizeClasses = "col-sm-12 col-md-6 col-xl-4 col-huge-3";
    return <div className="row gy-4">
        {loading && <>
            {[...Array(Math.min(6, results.hits?.length || 6))].map((x, i) => {
                return <div key={i} className={sizeClasses}>
                    <VenuePlaceholder />
                </div>;
            })}</>
        }

        {!loading && getPagedResults().map((venue) => {
            return <div key={venue.super_control_ref} className={sizeClasses}>
                <Venue venue={venue} price={venue.price} arrival_date={venue.arrival_date?.date} length_of_stay={searchValue.los} discount={venue.discount} special_offer={venue.special_offer} />
            </div>;
        })}

        {pageCount > 0 &&
            <div className="my-5 d-flex justify-content-center">
                <Pagination>
                    <Pagination.First onClick={() => setPage(1)} disabled={page <= 1} />
                    <Pagination.Prev onClick={() => setPage(Math.max(1, page - 1))} disabled={page <= 1} />
                    <li className="page-item"><span className="page-link text-secondary">Page {page} of {getPages()}</span></li>
                    <Pagination.Next onClick={() => setPage(Math.max(1, page + 1))} disabled={page >= getPages()} />
                    <Pagination.Last onClick={() => setPage(getPages())} disabled={page >= getPages()} />
                </Pagination>
            </div>
        }
    </div>
};

export default ListView;